import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleMinus } from '@fortawesome/pro-regular-svg-icons'

function FilterBubble({ icon, name, num, toggle, className }) {

    return (
        <button className={`btn-sm btn-outline ${className}`}>
            {icon && <FontAwesomeIcon className="" icon={icon} />} 
            <p className="">{name}</p>
            {num ? <p className="btn-bubble">{num}</p> : null}
            {toggle && <FontAwesomeIcon onClick={() => {toggle()}} className="" icon={faCircleMinus} />}
        </button>
    );
}

export default FilterBubble;
